// /frontend/src/plugins/index.ts

/**
 * This file acts as an entry point for all Vue plugins.
 * It imports individual plugin configurations and exports a single
 * `registerPlugins` function that is called in `main.ts` to
 * install them into the Vue application instance.
 */

// --- Import all plugin instances from the flattened structure ---
import vuetify from './vuetify';
import router from './vue-router';
import i18n from './i18n';
import pinia from './pinia';

// --- Type Imports ---
import type { App } from 'vue';

/**
 * Registers all application plugins with the root Vue app instance.
 *
 * @param app The root Vue application instance.
 *
 * @author Alexander Funke
 * @lastChange 2025-08-25
 */
export function registerPlugins(app: App): void {
  app
    .use(i18n)
    .use(pinia)
    .use(router)
    .use(vuetify);
}
